document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (event) => {
    const tabElement = event.target.closest('.content-box-collage__tabs-link');

    if (!tabElement) return;

    const tabId = tabElement.getAttribute('data-tab');
    const head = tabElement.closest('.content-box-collage__tabs-head');
    const block = tabElement.closest('.content-box-collage__tabs');

    if (!tabElement.classList.contains('active')) {
      head.querySelector('.active')?.classList.remove('active');
      block.querySelector('.content-box-collage__tabs-block.visible')?.classList.remove('visible');
      block.querySelector(`.content-box-collage__tabs-block[data-tab='${tabId}']`)?.classList.add('visible');

      tabElement.classList.add('active');
    }
  });
});
